import React from 'react';
import { Button } from '@common/Button';

const ErrorDisplay = ({ error }) => {
  return (
    <div className="absolute inset-0 flex items-center justify-center bg-gray-900/50 z-20">
      <div className="bg-red-500/10 text-red-400 p-6 rounded-lg max-w-md text-center">
        <h2 className="text-xl font-bold mb-2">Error Loading Map</h2>
        <p>{error}</p>
        <Button
          onClick={() => window.location.reload()}
          className="mt-4 bg-red-600 hover:bg-red-700 text-white px-4 py-2"
        >
          Refresh
        </Button>
      </div>
    </div>
  );
};

export default ErrorDisplay;